import { BaseModel } from '../models';
import { Expose } from 'class-transformer';

export class UpdateGroupDto extends BaseModel {
  @Expose()
  id!: string;

  @Expose()
  userId!: string;
}
